<script>
    import { defineComponent } from 'vue';

    export default {
        name: 'design-2021-analytics-group-link-modal',
        data() {
            return {
                display: false,
                group: null
            };
        },
        methods: {
            show(group) {
                this.group = group;
                this.display = true;
            },
            hideModal() {
                this.display = false;
            },
            updateGroup(){
                this.$emit('groupUpdated', this.group);
                this.hideModal();
            }
        }
    };
</script>

<template>
    <b-modal
        modal-class="apprentice-default-modal"
        v-model="display"
        :title="$t('analytics.add_label_to_group') + ` ${group && group.name}`"
        hide-footer
        :cancel-title="$t('common.cancel')"
        :ok-title="$t('common.save')">

        <design-2021-analytics-group-settings-component
            @tagged="updateGroup"
            @back="hideModal"
            :group-in="group">
        </design-2021-analytics-group-settings-component>
    </b-modal>

</template>

<style scoped lang="scss">

</style>